export default function IconExplode(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <path d="M12 2L8 8H3l4 4-2 6 7-4 7 4-2-6 4-4h-5z"/>
    </svg>
  )
}
